module.exports = __webpack_public_path__ + "img/usd-coin-cryptocurrency.a0d924d8.svg";